import { PureComponent, ReactNode } from 'react';
import { logout } from '../api/login';
import { setupUserInSentry } from '../App';
import { deleteDb } from '../store/idbHandler';
import { resetTracking } from '../tracking';
import { GO_TO_LOGIN } from '../routes/paths';
import { firebaseAuth } from '../firestore';

class Logout extends PureComponent {
    componentDidMount = async (): Promise<void> => {
        const urlParams = new URLSearchParams(window.location.search);
        const clear = urlParams.get('clear') || '';
        const shouldClear = clear === 'true';
        try {
            // TODO: clean up other db as well
            localStorage.clear();
            if (shouldClear) {
                await deleteDb();
            }

            resetTracking();
            setupUserInSentry();
            firebaseAuth.signOut();

            await logout();

            window.location.replace(GO_TO_LOGIN);
        } catch (error) {
            console.error(error);
        } finally {
            window.location.replace(GO_TO_LOGIN);
        }
    };

    render(): ReactNode {
        return null;
    }
}

export default Logout;
